(function () {
  'use strict';
  var PX = 'bm';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }

 var CLOSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
 var CAM = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="7.5" width="18" height="12.5" rx="2"/><path d="M8 7.5 9.4 5h5.2L16 7.5"/><circle cx="12" cy="13.8" r="3.3"/></svg>';
 var root = document.documentElement;
 root.classList.add('bm-js');
 function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
 function focusVisible(el) { try { return el.matches(':focus-visible'); } catch (e) { return true; } }
 function io(fn, opt) { return 'IntersectionObserver' in window ? new IntersectionObserver(fn, opt) : null; }
 try { if (localStorage.getItem('bm-motion') === 'off') root.classList.add('bm-still'); } catch (e) { }
 function paused() { return root.classList.contains('bm-still'); }
 function setPaused(on) {
  root.classList.toggle('bm-still', on);
  try { localStorage.setItem('bm-motion', on ? 'off' : 'on'); } catch (e) { }
  [].forEach.call(document.querySelectorAll('[data-bm-pause]'), function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
 }
 class BmHero extends HTMLElement {
  connectedCallback() {
   var self = this;
   this.prints = [].slice.call(this.querySelectorAll('[data-bm-print]'));
   this.live = this.querySelector('[data-bm-live]');
   var pb = this.querySelector('[data-bm-pause]');
   if (pb) { pb.hidden = false; pb.setAttribute('aria-pressed', paused() ? 'true' : 'false'); }
   this._click = function (e) {
    var t = e.target; if (!t.closest) return;
    if (t.closest('[data-bm-pause]')) { setPaused(!paused()); return; }
    var pr = t.closest('[data-bm-print]'); if (pr) self.front(pr);
   };
   this.addEventListener('click', this._click);
   this._io = io(function (es) { self.classList.toggle('is-off', !es[0].isIntersecting); });
   if (this._io) this._io.observe(this);
   if (!reduced()) {
    this._sc = function () {
     if (self._raf || self.classList.contains('is-off')) return;
     self._raf = requestAnimationFrame(function () {
      self._raf = 0;
      var r = self.getBoundingClientRect();
      self.style.setProperty('--bm-sc', Math.max(0, Math.min(1, -r.top / (r.height || 1))).toFixed(3));
     });
    };
    window.addEventListener('scroll', this._sc, { passive: true });
   }
  }
  front(pr) {
   var cur = this.prints.filter(function (p) { return p.getAttribute('data-slot') === '0'; })[0];
   if (!cur || cur === pr) return;
   var slot = pr.getAttribute('data-slot');
   cur.setAttribute('data-slot', slot); pr.setAttribute('data-slot', '0');
   this.prints.forEach(function (p) { p.setAttribute('aria-pressed', p === pr ? 'true' : 'false'); });
   var cap = pr.querySelector('.bm-print__cap');
   if (this.live) this.live.textContent = (cap ? cap.textContent.trim() : '') + ' ✓';
  }
  disconnectedCallback() {
   this.removeEventListener('click', this._click);
   if (this._io) this._io.disconnect();
   if (this._sc) window.removeEventListener('scroll', this._sc);
   if (this._raf) cancelAnimationFrame(this._raf);
  }
 }
 if (!customElements.get('bm-hero')) customElements.define('bm-hero', BmHero);
 class BmReveal extends HTMLElement {
  connectedCallback() {
   var self = this, els = [].slice.call(this.querySelectorAll('.bm-rv'));
   if (reduced()) return;
   this._io = io(function (es) {
    var n = 0;
    es.forEach(function (en) {
     if (!en.isIntersecting) return;
     en.target.style.setProperty('--bm-rd', (n++ * 80) + 'ms'); en.target.classList.add('is-in'); self._io.unobserve(en.target);
    });
   }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
   if (this._io) els.forEach(function (e) { self._io.observe(e); });
  }
  disconnectedCallback() { if (this._io) this._io.disconnect(); }
 }
 if (!customElements.get('bm-reveal')) customElements.define('bm-reveal', BmReveal);
 if (!customElements.get('bm-strip')) {
  customElements.define('bm-strip', class extends HTMLElement {
   connectedCallback() {
    var self = this, sec = this.closest('section') || document;
    this.track = this.querySelector('[data-bm-strip-track]');
    if (!this.track) return;
    this.frames = [].slice.call(this.track.querySelectorAll('[data-bm-fc]'));
    this.prev = sec.querySelector('[data-bm-strip-prev]'); this.next = sec.querySelector('[data-bm-strip-next]');
    this.fill = this.querySelector('[data-bm-strip-fill]');
    [sec.querySelector('[data-bm-strip-btns]'), this.querySelector('[data-bm-strip-foot]')].forEach(function (b) { if (b) b.hidden = false; });
    this.sec = sec;
    this._click = function (e) {
     var b = e.target.closest ? e.target.closest('[data-bm-strip-prev],[data-bm-strip-next]') : null; if (!b || b.disabled) return;
     self.step(b.hasAttribute('data-bm-strip-next') ? 1 : -1);
    };
    sec.addEventListener('click', this._click);
    this._sc = function () { if (!self._raf) self._raf = requestAnimationFrame(function () { self._raf = 0; self.update(); }); };
    this.track.addEventListener('scroll', this._sc, { passive: true });
    window.addEventListener('resize', this._sc);
    this.update();
   }
   step(dir) {
    var f = this.frames[0], w = f ? f.getBoundingClientRect().width + 16 : 300;
    if (this.track.scrollBy) this.track.scrollBy({ left: dir * w, behavior: reduced() ? 'auto' : 'smooth' }); else this.track.scrollLeft += dir * w;
   }
   update() {
    var t = this.track, max = t.scrollWidth - t.clientWidth, x = t.scrollLeft;
    if (this.fill) this.fill.style.transform = 'scaleX(' + (max > 0 ? Math.max(0.08, Math.min(1, x / max)) : 1).toFixed(3) + ')';
    if (this.prev) this.prev.disabled = x <= 2;
    if (this.next) this.next.disabled = x >= max - 2;
    if (reduced()) return;
    var c = t.getBoundingClientRect(), mid = c.left + c.width / 2;
    this.frames.forEach(function (f) { var r = f.getBoundingClientRect(), p = ((r.left + r.width / 2) - mid) / (c.width || 1); f.style.setProperty('--p', Math.max(-1, Math.min(1, p)).toFixed(3)); });
   }
   disconnectedCallback() {
    if (this.sec && this._click) this.sec.removeEventListener('click', this._click);
    if (this.track && this._sc) this.track.removeEventListener('scroll', this._sc);
    window.removeEventListener('resize', this._sc);
    if (this._raf) cancelAnimationFrame(this._raf);
   }
  });
 }
 function biz(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
 function shortDate(d) { try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return ''; } }
 if (!customElements.get('bm-eta')) {
  customElements.define('bm-eta', class extends HTMLElement {
   connectedCallback() {
    var a = shortDate(biz(7)), b = shortDate(biz(10)), lead = this.getAttribute('data-lead') || '';
    if (a && b) this.textContent = (lead ? lead + ' ' : '') + a + ' – ' + b;
   }
  });
 }
 if (!customElements.get('bm-pill')) {
  customElements.define('bm-pill', class extends HTMLElement {
   connectedCallback() {
    var self = this;
    this.btn = document.querySelector(this.getAttribute('data-hero-add'));
    this.foot = document.querySelector('.site-footer');
    this.mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: true };
    this.st = { above: false, foot: false, typing: false };
    this._io = this.btn ? io(function (es) {
     es.forEach(function (e) {
      if (e.target === self.btn) self.st.above = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      else self.st.foot = e.isIntersecting;
     });
     self.apply();
    }) : null;
    if (!this._io) return;
    [this.btn, this.foot].forEach(function (x) { if (x) self._io.observe(x); });
    this._fi = function (e) { self.st.typing = e.type === 'focusin' && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName); self.apply(); };
    document.addEventListener('focusin', this._fi); document.addEventListener('focusout', this._fi);
    this._mq = function () { self.apply(); };
    if (this.mq.addEventListener) this.mq.addEventListener('change', this._mq);
   }
   apply() {
    var s = this.st, on = s.above && !s.foot && !s.typing && this.mq.matches;
    this.classList.toggle('is-in', on);
    if (on) { this.removeAttribute('aria-hidden'); this.removeAttribute('inert'); }
    else { this.setAttribute('aria-hidden', 'true'); this.setAttribute('inert', ''); }
   }
   disconnectedCallback() {
    if (this._io) this._io.disconnect();
    document.removeEventListener('focusin', this._fi); document.removeEventListener('focusout', this._fi);
    if (this.mq.removeEventListener && this._mq) this.mq.removeEventListener('change', this._mq);
   }
  });
 }
 function anchorId(a) {
  var h = a.getAttribute('href') || '', i = h.lastIndexOf('#');
  if (i < 0 || i === h.length - 1) return '';
  var id = h.slice(i + 1), base = h.slice(0, i).replace(/^#/, '');
  if (!id || id.charAt(0) === '/') return '';
  if (base && base !== '/' && base !== location.pathname) return '';
  return id;
 }
 if (!customElements.get('bm-spy')) {
  customElements.define('bm-spy', class extends HTMLElement {
   connectedCallback() {
    var self = this;
    this._on = {};
    this._click = function (e) {
     if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
     var a = e.target.closest ? e.target.closest('a[href]') : null; if (!a) return;
     var id = anchorId(a); if (!id) return;
     var t = document.getElementById(id); if (!t) return;
     e.preventDefault();
     t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
     try { history.replaceState(null, '', '#' + id); } catch (er) { }
     if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
     try { t.focus({ preventScroll: true }); } catch (er) { }
    };
    document.addEventListener('click', this._click);
    this.watch();
   }
   watch() {
    var self = this;
    this.links = [];
    [].forEach.call(document.querySelectorAll('.bm-tab-link'), function (a) {
     var id = anchorId(a), el = id && document.getElementById(id);
     if (el) self.links.push({ a: a, id: id, el: el });
     else if (id && a.parentNode && a.parentNode.tagName === 'LI') a.parentNode.hidden = true;
    });
    this._io = io(function (es) { es.forEach(function (en) { self._on[en.target.id] = en.isIntersecting; }); self.mark(); },
     { rootMargin: '-20px 0px -' + Math.round(window.innerHeight * 0.5) + 'px 0px', threshold: 0 });
    if (!this._io) return;
    var seen = [];
    this.links.forEach(function (l) { if (seen.indexOf(l.el) < 0) { seen.push(l.el); self._io.observe(l.el); } });
    seen.sort(function (a, b) { return (a.compareDocumentPosition(b) & 4) ? -1 : 1; });
    this._els = seen;
   }
   mark() {
    var cur = '';
    (this._els || []).forEach(function (el) { if (this._on[el.id]) cur = el.id; }, this);
    this.links.forEach(function (l) {
     var on = l.id === cur;
     l.a.classList.toggle('is-current', on);
     if (on) l.a.setAttribute('aria-current', 'location'); else if (l.a.getAttribute('aria-current') === 'location') l.a.removeAttribute('aria-current');
    });
   }
   disconnectedCallback() { document.removeEventListener('click', this._click); if (this._io) this._io.disconnect(); }
  });
 }
 if (!customElements.get('bm-panels')) {
  customElements.define('bm-panels', class extends HTMLElement {
   connectedCallback() {
    var self = this;
    this._list = this.querySelector('[data-bm-tablist]');
    this._tabs = [].slice.call(this.querySelectorAll('[data-bm-tab]'));
    this._panels = [].slice.call(this.querySelectorAll('[data-bm-panel]'));
    if (!this._list || !this._tabs.length) return;
    this._click = function (e) {
     var t = e.target.closest ? e.target.closest('[data-bm-tab]') : null;
     if (t) self.select(self._tabs.indexOf(t), false);
    };
    this._key = function (e) {
     var t = e.target.closest ? e.target.closest('[data-bm-tab]') : null; if (!t) return;
     var i = self._tabs.indexOf(t), n = self._tabs.length, j = -1;
     if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n;
     else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + n) % n;
     else if (e.key === 'Home') j = 0;
     else if (e.key === 'End') j = n - 1;
     if (j < 0) return;
     e.preventDefault(); self.select(j, true);
    };
    this._list.addEventListener('click', this._click);
    this._list.addEventListener('keydown', this._key);
    var cur = 0;
    this._tabs.forEach(function (t, n) { if (t.getAttribute('aria-selected') === 'true') cur = n; });
    this.setAttribute('data-ready', '');
    this.select(cur, false);
   }
   select(i, focus) {
    if (i < 0 || i >= this._tabs.length) return;
    this._tabs.forEach(function (t, n) { var on = n === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
    this._panels.forEach(function (p, n) { p.hidden = n !== i; });
    if (focus) { var tab = this._tabs[i]; try { tab.focus({ preventScroll: true }); } catch (e) { tab.focus(); } }
   }
   disconnectedCallback() {
    if (this._list && this._click) { this._list.removeEventListener('click', this._click); this._list.removeEventListener('keydown', this._key); }
   }
  });
 }
 if (!customElements.get('bm-dots')) {
  customElements.define('bm-dots', class extends HTMLElement {
   connectedCallback() {
    var self = this;
    this.gallery = this.closest('boostly-gallery');
    this.track = this.gallery && this.gallery.querySelector('[data-gallery-track]');
    if (!this.track) return;
    this.slides = [].slice.call(this.track.querySelectorAll('.gallery__slide'));
    this.dots = [].slice.call(this.querySelectorAll('[data-bm-dot]'));
    this.cur = this.querySelector('[data-bm-cur]');
    this.mq = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: false };
    this.media = this.closest('.product__media');
    this._pio = this.media ? io(function (es) { self.media.classList.toggle('is-off', !es[0].isIntersecting); }) : null;
    if (this._pio) this._pio.observe(this.media);
    this._click = function (e) {
     var d = e.target.closest ? e.target.closest('[data-bm-dot]') : null;
     if (d) self.goTo(Number(d.getAttribute('data-bm-dot')));
    };
    this.addEventListener('click', this._click);
    this._scroll = function () {
     if (!self.mq.matches) return;
     if (!self._raf) self._raf = requestAnimationFrame(function () { self._raf = 0; self.sync(); });
     clearTimeout(self._settle); self._settle = setTimeout(function () { self.settle(); }, 150);
    };
    this.track.addEventListener('scroll', this._scroll, { passive: true });
    this._stop = function (e) { e.stopPropagation(); };
    this.viewport = this.track.parentNode;
    this.viewport.addEventListener('touchstart', this._stop, { capture: true, passive: true });
    this.viewport.addEventListener('touchend', this._stop, { capture: true, passive: true });
    this._mo = new MutationObserver(function () {
     if (!self.mq.matches) return;
     var a = self.activeIndex();
     if (a > -1 && a !== self.idx()) self.goTo(a);
    });
    this.slides.forEach(function (s) { self._mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    this.sync();
   }
   idx() { var w = this.track.clientWidth || 1; return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / w))); }
   activeIndex() { var a = -1; this.slides.forEach(function (s, n) { if (s.classList.contains('is-active')) a = n; }); return a; }
   goTo(i) {
    if (i < 0 || i >= this.slides.length) return;
    var w = this.track.clientWidth;
    if (this.track.scrollTo) this.track.scrollTo({ left: i * w, behavior: reduced() ? 'auto' : 'smooth' });
    else this.track.scrollLeft = i * w;
    this.mark(i);
   }
   mark(i) {
    this.dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    if (this.cur) this.cur.textContent = String(i + 1);
   }
   sync() { this.mark(this.idx()); }
   settle() {
    var i = this.idx(), s = this.slides[i];
    this.mark(i);
    if (s && !s.classList.contains('is-active') && this.gallery && typeof this.gallery.show === 'function') this.gallery.show(s.getAttribute('data-media-id'));
   }
   disconnectedCallback() {
    this.removeEventListener('click', this._click);
    if (this.track && this._scroll) this.track.removeEventListener('scroll', this._scroll);
    if (this.viewport && this._stop) { this.viewport.removeEventListener('touchstart', this._stop, true); this.viewport.removeEventListener('touchend', this._stop, true); }
    if (this._mo) this._mo.disconnect();
    if (this._pio) this._pio.disconnect();
    clearTimeout(this._settle);
    if (this._raf) cancelAnimationFrame(this._raf);
   }
  });
 }
 var HOLD_MS = 8000, lastKb = null, live = null, bar = null;
 class BmBar extends HTMLElement {
  connectedCallback() {
   if (this.built) return; this.built = true;
   var self = this, W = words(), nm = document.querySelector('.bm-top__text');
   this.className = 'bm-ui';
   this.setAttribute('role', 'region'); this.setAttribute('aria-label', W.added || ''); this.setAttribute('aria-hidden', 'true');
   this.innerHTML = '<div class="page-width bm-ui__wrap"><div class="bm-ui__tile"><span class="bm-tape bm-tape--l" aria-hidden="true"></span><span class="bm-tape bm-tape--r" aria-hidden="true"></span>' +
    '<span class="bm-ui__app"><span class="bm-ui__av" aria-hidden="true">' + CAM + '</span><span class="bm-ui__brand">' + esc(nm ? nm.textContent.trim() : '') + '</span><span class="bm-ui__when">' + esc(W.now) + '</span></span>' +
    '<button type="button" class="bm-ui__x" aria-label="' + esc(W.close) + '">' + CLOSE + '</button>' +
    '<span class="bm-ui__msg"><span class="bm-ui__pic"></span><span class="bm-ui__text"><span class="bm-ui__title"></span><span class="bm-ui__meta"></span><span class="bm-ui__ship">' + esc(W.ship) + '</span></span></span>' +
    '<div class="bm-ui__ev"></div>' +
    '<span class="bm-ui__actions"><a class="bm-ui__btn bm-ui__btn--ghost" href="' + esc(cartUrl()) + '">' + esc(W.view_cart) + '</a>' +
    '<a class="bm-ui__btn" href="' + esc(checkoutUrl()) + '">' + esc(W.checkout) + '</a></span>' +
    '<span class="bm-ui__line" aria-hidden="true"></span></div></div>';
   var tpl = document.getElementById('bm-ev-cart'), slot = this.querySelector('.bm-ui__ev');
   if (tpl && tpl.content && tpl.content.querySelector('[data-ev]')) slot.appendChild(tpl.content.cloneNode(true));
   this.isOpen = false; this.hp = false; this.hf = false; this.timer = 0; this.liveTimer = 0; this.due = 0; this.left = HOLD_MS; this.token = 0;
   this.onKey = function (e) { if (e.key === 'Escape') self.hide(true); };
   this.addEventListener('click', function (e) { if (e.target.closest('.bm-ui__x')) self.hide(true); });
   this.addEventListener('pointerenter', function () { self.hp = true; self.pause(); });
   this.addEventListener('pointerleave', function () { self.hp = false; self.pause(); });
   this.addEventListener('focusin', function (e) { self.hf = focusVisible(e.target); self.pause(); });
   this.addEventListener('focusout', function () { self.hf = false; self.pause(); });
  }
  disconnectedCallback() {
   clearTimeout(this.timer); clearTimeout(this.liveTimer);
   document.removeEventListener('keydown', this.onKey);
  }
  arm(ms) { clearTimeout(this.timer); this.left = ms; this.due = Date.now() + ms; var self = this; this.timer = setTimeout(function () { self.hide(false); }, ms); }
  pause() {
   var on = this.hp || this.hf; if (!this.isOpen || on === this.classList.contains('is-held')) return;
   this.classList.toggle('is-held', on);
   if (on) { clearTimeout(this.timer); this.left = Math.max(1500, this.due - Date.now()); } else this.arm(this.left);
  }
  fill(it, W) {
   var title = it ? ((W.added_item || '') + ' ' + (it.product_title || it.title || '')).trim() : (W.added || '');
   this.querySelector('.bm-ui__title').textContent = title;
   this.querySelector('.bm-ui__pic').innerHTML = pic(it && (it.image || (it.featured_image && it.featured_image.url)), 56);
   var meta = [];
   if (it && it.variant_title && !/^default title$/i.test(it.variant_title)) meta.push(it.variant_title);
   if (it) meta.push(it.quantity + ' × ' + money(it.final_price != null ? it.final_price : (it.final_line_price || 0) / (it.quantity || 1)));
   this.querySelector('.bm-ui__meta').textContent = meta.join(' · ');
   return title + (meta.length ? '. ' + meta.join(', ') : '');
  }
  show(it) {
   var W = words(), self = this, token = ++this.token, said = this.fill(it, W);
   if (this.isOpen) { var ln = this.querySelector('.bm-ui__line'); ln.parentNode.replaceChild(ln.cloneNode(true), ln); }
   this.style.setProperty('--bm-ui-dur', (HOLD_MS / 1000) + 's');
   var kb = lastKb && document.contains(lastKb) && !this.contains(lastKb) ? lastKb : null; lastKb = null; lastFocus = kb;
   this.classList.remove('is-held'); this.hp = this.matches(':hover'); this.hf = false;
   this.classList.add('is-open'); this.setAttribute('aria-hidden', 'false'); this.isOpen = true;
   document.addEventListener('keydown', this.onKey);
   if (this.hp) { this.classList.add('is-held'); this.left = HOLD_MS; } else this.arm(HOLD_MS);
   this.say(said);
   if (kb) { var a = this.querySelector('.bm-ui__btn'); if (a) a.focus(); }
   T().cart.get().then(function (c) {
    if (token !== self.token || !c) return;
    var m = self.querySelector('.bm-ui__meta'), base = m.textContent;
    m.textContent = (base ? base + ' · ' : '') + count(c.item_count, W) + ' · ' + W.subtotal + ' ' + money(c.total_price);
   }).catch(function () {});
  }
  say(msg) {
   if (!live) { live = document.createElement('div'); live.className = 'bm-ui__live'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
   live.textContent = ''; clearTimeout(this.liveTimer); this.liveTimer = setTimeout(function () { live.textContent = msg; }, 60);
  }
  hide(back) {
   if (!this.isOpen) return; this.isOpen = false; this.token++;
   clearTimeout(this.timer);
   document.removeEventListener('keydown', this.onKey);
   var inside = this.contains(document.activeElement);
   this.classList.remove('is-open', 'is-held'); this.setAttribute('aria-hidden', 'true');
   if (inside || back) { if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus(); else if (inside && document.activeElement && document.activeElement.blur) document.activeElement.blur(); }
  }
 }
 if (!customElements.get('bm-bar')) customElements.define('bm-bar', BmBar);
 function getBar() {
  if (bar && document.body.contains(bar)) return bar;
  bar = document.querySelector('bm-bar') || document.body.appendChild(document.createElement('bm-bar')); return bar;
 }
 function item() { var l = lastAdded; return l ? (l.items && l.items[0]) || (l.product_title ? l : null) : null; }
 function afterAdd(after) {
  if (after === 'cart') return false;
  getBar().show(item());
  return true;
 }
 function init() {
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') lastKb = e.target; }, true);
  document.addEventListener('pointerdown', function () { lastKb = null; }, true);
 }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'bm';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
